import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { AdHocBillModal } from '~/components/BillModal/AdHocBillModal/AdHocBillModal';
import { SmartBillClientModal } from '~/components/BillModal/BillClientModal/SmartBillClientModal/SmartBillClientModal';
export const useBillModalLauncher = ()=>{
    const { showModal } = useOverlayContext();
    const openBillClient = (relationshipId)=>{
        showModal({
            biName: 'bill_client_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(SmartBillClientModal, {
                    relationshipId: relationshipId,
                    dismissModal: dismissModal
                });
            }
        });
    };
    const openAdHocBill = (relationshipId)=>{
        showModal({
            biName: 'ad_hoc_bill_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(AdHocBillModal, {
                    relationshipId: relationshipId,
                    dismissModal: dismissModal
                });
            }
        });
    };
    return {
        openBillClient,
        openAdHocBill
    };
};
